import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

export function login(loginData) {
  return axios.post(API_URL.LOGIN, loginData);
}

export function register(userData) {
  return axios.post(API_URL.REGISTER, userData);
}

export function findId(params) {
  return axios.get(API_URL.FIND_ID, {params});
}

export function editMyInfo(data) {
  return axios.put(API_URL.EDIT_MY_INFO, data);
}

export function changePassword(data) {
  return axios.put(API_URL.CHANGE_PW, data);
}

export function checkId(params) {
  return axios.get(API_URL.CHECK_ID, {params});
}

export function sendMobileCert(telNo) {
  return axios.post(API_URL.SEND_CERT_NUM, {telNo});
}

export function validMobileCert(validData) {
  return axios.post(API_URL.VALID_CERT_NUM, validData);
}

export function requestPassword({email}) {
  return axios.post(API_URL.CHANGE_PW, {email});
}

export function getUserByToken() {
  return axios.get(API_URL.ME_URL);
}

export function checkBankAccount(params) {
  return axios.get(API_URL.CHECK_BANK_ACCOUNT, {params});
}
